import Vue from 'vue';
import Vuex from 'vuex';
import {
	getAuthFromCookie,
	getUserFromCookie,
	saveAuthToCookie,
	saveUserToCookie,
} from '@/utils/cookies';

import {
	saveWishlistStorage,
	saveCartStorage,
	getWishlistStorage,
	getCartStorage,
} from '@/utils/storage';
import { signinUser } from '@/api/users';
import { getAddress, getAllAddress } from '@/api/address';
Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		userId: getUserFromCookie() || '',
		token: getAuthFromCookie() || '',
		address: '',
		allAddress: [],
		product: {},
		wishlist: getWishlistStorage() || [],
		cart: getCartStorage() || [],
		cartTotal: 0,
	},
	getters: {
		isLogin(state) {
			return state.userId !== '';
		},
		allAddress(state) {
			return state.allAddress;
		},
		getWishlist(state) {
			return state.wishlist;
		},
		getProduct(state) {
			return state.product;
		},
		getCart(state) {
			return state.cart;
		},
		getCartTotal(state) {
			const cart = state.cart;
			const total = cart.reduce((sum, v) => {
				if (v.groupBuying > 0) {
					return sum + v.endPrice;
				}
				return sum + v.sellPrice;
			}, 0);
			return total;
		},
		getOrderTotal(state) {
			const cart = state.cart;
			const total = cart.reduce((sum, v) => {
				if (v.groupBuying > 0) {
					return sum + v.endPrice * v.qty + v.opPrice * v.qty;
				}
				return sum + v.sellPrice * v.qty + v.opPrice * v.qty;
			}, 0);
			return total;
		},
	},
	mutations: {
		setUserId(state, userId) {
			state.userId = userId;
		},
		clearUserId(state) {
			state.userId = '';
		},
		setToken(state, token) {
			state.token = token;
		},
		setAddress(state, address) {
			state.address = address;
		},
		setAllAddress(state, address) {
			state.allAddress = address;
		},
		setProudct(state, product) {
			state.product = product;
		},
		setWishlist(state, prodt) {
			let isProduct = false;
			const isKey = Object.keys(prodt).includes('product');
			console.log(isKey);

			if (isKey) {
				var { product, qty, opName, opPrice } = prodt;
				console.log(product);

				isProduct = window._.some(state.cart, {
					productId: product.productId,
				});

				if (isProduct) {
					alert('이미 추가한 상품 입니다.');
					return;
				}

				product.qty = qty || 1;
				product.opName = opName || '';
				product.opPrice = opPrice || 0;
				state.cart.push(product);
				saveCartStorage(state.cart);
			} else {
				var prod = prodt;
				isProduct = window._.some(state.wishlist, {
					productId: prod.productId,
				});
				if (isProduct) {
					alert('이미 추가한 상품 입니다.');
					return;
				}
				prod.qty = qty;
				prod.opName = opName;
				prod.opPrice = opPrice;
				state.wishlist.push(prod);
				saveWishlistStorage(state.wishlist);
			}
		},
		setResetWishlist(state, productId) {
			state.wishlist = window._.remove(state.wishlist, item => {
				return item.productId != productId;
			});
			saveWishlistStorage(state.wishlist);
		},
		setCart(state, prodt) {
			let isProduct = false;

			const isKey = Object.keys(prodt).includes('product');
			console.log(isKey);

			if (isKey) {
				var { product, qty, opName, opPrice } = prodt;
				console.log(product);

				isProduct = window._.some(state.cart, {
					productId: product.productId,
				});

				if (isProduct) {
					alert('이미 추가한 상품 입니다.');
					return;
				}

				product.qty = qty || 1;
				product.opName = opName || '';
				product.opPrice = opPrice || 0;
				state.cart.push(product);
				saveCartStorage(state.cart);
			} else {
				var prod = prodt;
				isProduct = window._.some(state.cart, {
					productId: prod.productId,
				});
				if (isProduct) {
					alert('이미 추가한 상품 입니다.');
					return;
				}
				prod.qty = qty || 1;
				prod.opName = opName || '';
				prod.opPrice = opPrice || 0;
				state.cart.push(prod);
				saveCartStorage(state.cart);
			}
		},
		setResetCart(state, productId) {
			state.cart = window._.remove(state.cart, item => {
				return item.productId != productId;
			});
			saveCartStorage(state.cart);
		},
		setQtyCart(state, product) {
			const cart = state.cart;
			cart.map(v => {
				if (v.productId === product.productId) {
					v.qty = product.qty;
					return v;
				}
				return v;
			});
			saveCartStorage(cart);
		},
	},
	actions: {
		async SIGNIN_USER({ commit }, userData) {
			const { data } = await signinUser(userData);
			if (data.success === 'false') return data.success;
			const token = data.token;
			commit('setToken', token);
			commit('setUserId', data.users.userId);
			saveAuthToCookie(token);
			saveUserToCookie(data.users.userId);
			return data.success;
		},
		async GET_ADDRESS({ commit }) {
			const { data } = await getAddress(this.state.userId);
			commit('setAddress', data);
			return data;
		},
		async GET_ALL_ADDRESS({ commit }) {
			const { data } = await getAllAddress(this.state.userId);
			commit('setAllAddress', data);
			return data;
		},
		SET_PRODUCT({ commit }, product) {
			commit('setProudct', product);
			return;
		},
		SET_WISHLIST({ commit }, product) {
			console.log(product);
			commit('setWishlist', product);
			return;
		},
		SET_REMOVE_WISHITEM({ commit }, productId) {
			commit('setResetWishlist', productId);
			return;
		},
		SET_CART({ commit }, product) {
			commit('setCart', product);
			return;
		},
		SET_REMOVE_CART({ commit }, productId) {
			commit('setResetCart', productId);
			return;
		},
		SET_QTY_CART({ commit }, product) {
			commit('setQtyCart', product);
			return;
		},
	},
});
